import React from 'react';
import imagePath from '../../../assets/images/blogs/Mindfulness and well being Thumbnail.png'


const MindfulnessWellBeingPage = () => {

    return (
        <div className="container my-5">
            <img
                src={imagePath}
                alt="Mindfulness and Well-being"
                className="img-fluid rounded mb-4 w-100"
                style={{ maxHeight: '400px', objectFit: 'cover' }}
            />

            <h1 className="mb-3">Mindfulness and Well-Being</h1>
            <p className="lead">
                In a world full of distractions, we often rush through tasks without truly experiencing the moment. This disconnection can lead to stress, fatigue, and a feeling of imbalance. What we need is <strong>mindfulness</strong>.
            </p>

            <h4 className="mt-4">🧘‍♀️ What is Mindfulness?</h4>
            <p>
                Mindfulness is the practice of focusing your attention fully on the present moment—without judgment. It enhances self-awareness, emotional regulation, and mental clarity.
            </p>

            <h4 className="mt-4">💡 Why Mindfulness Matters</h4>
            <ul>
                <li>Helps you savour life’s small joys as they happen</li>
                <li>Improves engagement in everyday activities</li>
                <li>Builds resilience to handle stress and setbacks</li>
                <li>Reduces overthinking and anxiety about the future</li>
                <li>Fosters deeper relationships with others</li>
            </ul>

            <h4 className="mt-4">🌱 Habits for a Mindful, Healthy Life</h4>
            <p>Try integrating these habits into your routine:</p>
            <ul>
                <li>Reduce screen time and be intentional with device use</li>
                <li>Exercise regularly—even a daily walk helps</li>
                <li>Eat a balanced, nutritious diet</li>
                <li>Prioritize sleep to restore energy and focus</li>
                <li>Keep your surroundings clean and organized</li>
            </ul>

            <h4 className="mt-4">🎯 Balancing Academics and Mental Health</h4>
            <p>
                Productivity thrives on balance—not pressure. Here’s how to manage both your studies and well-being:
            </p>
            <ul>
                <li>Set realistic goals and expectations</li>
                <li>Stay organized with to-do lists or calendars</li>
                <li>Take breaks and practice self-care</li>
                <li>Give yourself credit for small achievements</li>
                <li>Limit social media use when feeling overwhelmed</li>
            </ul>

            <h4 className="mt-4">🤝 Don’t Isolate—Connect</h4>
            <p>
                It’s okay to talk about your feelings. Speak to friends, family, or mentors. Taking a break, expressing emotions, and allowing support are crucial steps in maintaining a balanced life.
            </p>

            <p className="mt-4 text-muted">– Malvika, student of Mrs. Yogita Kumar</p>
        </div>
    );
};

export default MindfulnessWellBeingPage;
